import { render } from "./question-drawer.vue?vue&type=template&id=0dc1f983&lang=pug"
import script from "./question-drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./question-drawer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__